import React, { useState, useEffect, useRef } from 'react';
import { profileImage } from './ImageList';

export default function ProfilePopup() {
    const [isProfilePopupOpen, setIsProfilePopupOpen] = useState(false);
    const [isTriggerVisible, setIsTriggerVisible] = useState(true);
    const scrollTimeoutRef = useRef(null);
    const [profileImageSrc, setProfileImageSrc] = useState(localStorage.getItem('profileImage') || profileImage);
    const [firstName, setFirstName] = useState(localStorage.getItem('firstName') || '');
    const [lastName, setLastName] = useState(localStorage.getItem('lastName') || '');
    const [email, setEmail] = useState(localStorage.getItem('email') || '');
    const [phone, setPhone] = useState(localStorage.getItem('phone') || '');

    useEffect(() => {
        const handleScroll = () => {
            setIsTriggerVisible(false);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
            scrollTimeoutRef.current = setTimeout(() => {
                setIsTriggerVisible(true);
            }, 200);
        };

        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
            if (scrollTimeoutRef.current) {
                clearTimeout(scrollTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        const handleProfileDataUpdate = () => {
            setProfileImageSrc(localStorage.getItem('profileImage') || profileImage);
            setFirstName(localStorage.getItem('firstName') || '');
            setLastName(localStorage.getItem('lastName') || '');
            setEmail(localStorage.getItem('email') || '');
            setPhone(localStorage.getItem('phone') || '');
        };

        window.addEventListener('profileDataUpdated', handleProfileDataUpdate);
        return () => window.removeEventListener('profileDataUpdated', handleProfileDataUpdate);
    }, []);

    const triggerStyle = {
        opacity: isTriggerVisible ? 1 : 0,
        visibility: isTriggerVisible ? 'visible' : 'hidden',
        transform: isTriggerVisible ? 'translateY(0)' : 'translateY(20px)',
        pointerEvents: isTriggerVisible ? 'auto' : 'none',
        transition: 'opacity 0.35s ease, visibility 0.35s ease, transform 0.35s ease'
    };

    return (
        <>
            {/* <!-- Mobile Profile Popup --> */}
            <div className={`profile-popup-wrapper ${isProfilePopupOpen ? 'is-open' : ''}`}>
                <button
                    className="profile-popup-trigger"
                    onClick={() => setIsProfilePopupOpen(true)}
                    style={triggerStyle}
                >
                    <img src={profileImageSrc} alt="Profile" className="profile-popup-trigger-img" />
                </button>
                <div className="profile-popup-content">
                    <div className="profile-popup-header">
                        <img src={profileImageSrc} alt="Profile" className="profile-popup-header-img" />
                        <button className="profile-popup-close" onClick={() => setIsProfilePopupOpen(false)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M15 5L5 15M5 5L15 15" stroke="#0E0E0E" strokeWidth="2" strokeLinecap="round"
                                    strokeLinejoin="round" />
                            </svg>
                        </button>
                    </div>
                    <div className="profile-popup-info">
                        <h3 className="profile-popup-name">{firstName} {lastName}</h3>
                        <p className="profile-popup-email">{email}</p>
                        <div className="profile-popup-actions">
                            <button className="profile-action-btn" aria-label="Call" onClick={() => window.location.href = `tel:${phone}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M22 16.92V19.92C22 20.8801 21.2159 21.6652 20.2558 21.6753C19.2898 21.6855 18.3319 21.5801 17.3998 21.3612C14.5498 20.7188 11.9048 19.3712 9.66978 17.4202C7.52779 15.5602 5.75279 13.1862 4.45479 10.4582C3.63079 8.67818 3.14179 6.76018 3.00979 4.80018C2.95479 3.83018 3.66979 3.00018 4.62979 3.00018H7.62979C8.56979 3.00018 9.35979 3.71018 9.46979 4.64018C9.63979 6.14018 9.99979 7.60018 10.5398 8.98018C10.7798 9.58018 10.5998 10.2502 10.0798 10.6202L8.61979 11.6802C10.0798 14.4502 12.5498 16.9202 15.3198 18.3802L16.3798 16.9202C16.7498 16.4002 17.4198 16.2202 18.0198 16.4602C19.3998 17.0002 20.8598 17.3602 22.3598 17.5302C23.2898 17.6402 23.9998 18.4302 23.9998 19.3702L22 16.92Z"
                                        fill="#1C4CAF" />
                                </svg>
                            </button>
                            <button className="profile-action-btn" aria-label="Text" onClick={() => window.location.href = `sms:${phone}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z"
                                        fill="#1C4CAF" />
                                </svg>
                            </button>
                            <button className="profile-action-btn" aria-label="Email" onClick={() => window.location.href = `mailto:${email}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                    <path
                                        d="M20 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 8L12 13L4 8V6L12 11L20 6V8Z"
                                        fill="#1C4CAF" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}